// Exports the "toc" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/toc')
//   ES2015:
//     import 'tinymce/plugins/toc'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ./~/tinymce/plugins/toc/index.js
// module id = loUf
// module chunks = 1